//insta btn
jQuery(function() {
    var topBtn = $('#insta-btn');
    topBtn.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 600) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    /*topBtn.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });*/
});
  $(document).ready(function() {
    // 各 <dd> タグに対して処理を実行
    $('.ac-area dd').each(function() {
      var ddContent = $(this).text().trim(); // <dd> タグ内の内容を取得し、前後の空白を除去

      // もし <dd> タグ内が空であれば、親の <dt> タグと <dd> タグを非表示にする
      if (ddContent === '') {
        $(this).prev('dt').hide(); // 親の <dt> タグを非表示にする
        $(this).hide(); // 現在の <dd> タグを非表示にする
      }
    });
  });
$('.header_menu_link').on('click', function(){
    $('.header_menu').toggleClass('is-active');
});
$('.search_btn_link').on('click', function(){
    $('.pc_header_search_box').toggleClass('is-active');
});
$('.link-list-sp').on('click', function(){
    $('.link-list-sp').toggleClass('add');
});

function FixedAnime() {
	var headerH = $('.header-logo-wrapper').outerHeight(true);
	var scroll = $(window).scrollTop();
	if (scroll >= headerH + 180){
		$('.header-logo-wrapper').addClass('fixed');
	}else{
		$('.header-logo-wrapper').removeClass('fixed');
	}
}

$(window).scroll(function () {
	FixedAnime();
});
$(window).on('load', function () {
	FixedAnime();
});

$('#page-top-btn').click(function() {
	$('html, body').animate({scrollTop:0}, 'linear');
	return false;
});

$(function () {
	var pagetop = $('#page-top-btn');
	pagetop.hide();
	$(window).scroll(function () {
		if ($(this).scrollTop() > 600) {
			pagetop.fadeIn();
		} else {
			pagetop.fadeOut();
		}
	});
});


$('.link-list-sp-open').on('click', function(){
	$(this).next('.link-list-sp-close').slideToggle();
});
$('.faq_list_Q').on('click', function(){
	$(this).toggleClass('is-open');
	$(this).next('.faq_list_A').slideToggle();
});

//accordion
$(function(){
  $(".ac-btn").click(function(){
    $(this).nextAll().slideToggle();
     $(this).toggleClass("active");
  return false;
 });
});

//svg
window.addEventListener('load', function(){
  deSVG('.img-svg', true);
});


//scroll mv
$(function() {
	$(window).scroll(function () {
		var top = $(this).scrollTop();
		if(top <= 0) {
			$("#mv1").css('opacity','1');
		}
		if(top > 150) {
			$("#mv1").css('opacity','0.8');
		}
		if(top > 300) {
			$("#mv1").css('opacity','0.65');
		}
		if(top > 500) {
			$("#mv1").css('opacity','0.4');
		}
		if(top > 1000) {
			$("#mv1").css('opacity','0.2');
		}
		if(top > 1500) {
			$("#mv1").css('opacity','0');
		}
	});
});

//anker link

$(function () {
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    $(href)[0].scrollIntoView({
      block: "start",
    });
    return false;
  });
});

$(function(){
	// 目次の出力に使用する変数
	var toc = '<ol>';
	// 目次の階層の判断に使用する変数
	var hierarchy;
	// h2・h3の判断に使用する変数 
	var element = 0;
	// 目次の項目数をカウントする変数
	var count = 0;
	
	$('.blog-contents-wrap h2, .blog-contents-wrap h3').each(function(){
		// 目次の項目数のカウントを増加 
		count ++;  
		// h2・h3タグにIDの属性値を指定
		this.id = 'chapter-' + count;
		
		// 現在のループで扱う要素を判断する条件分岐
		if(this.nodeName == 'H2'){
			element = 0;
		}else{               
			element = 1;
		}  
		
		// 現在の状態を判断する条件分岐
		if(hierarchy === element){ // h2またはh3がそれぞれ連続する場合
			toc += '</li>';
		}else if(hierarchy < element){ // h2の次がh3となる場合
			toc += '<ol>';               
			hierarchy = 1;
		}else if(hierarchy > element){ // h3の次がh2となる場合
			toc += '</li></ol></li>';               
			hierarchy  = 0;
		}else if(count == 1){ // 最初の項目の場合
			hierarchy = 0;
		} 
		
		// 目次の項目を作成。※次のループで<li>の直下に<ol>タグを出力する場合ががあるので、ここでは<li>タグを閉じていません。
		toc += '<li><a href="#' + this.id + '">' + $(this).html() + '</a>';
	});
	
	// 目次の最後の項目をどの要素から作成したかにより、タグの閉じ方を変更
	if(element == 0){
		toc += '</li></ol>';
	}else if(element == 1){
		toc += '</li></ol></li></ol>';
	}
	
	// ページ内のh2・h3タグが3つ以上の場合に目次を出力
	if(count < 3){
		$('#nav-area').remove();
	}else{
		$('#nav-area').html(toc);
	}
});

$(function() {
    $(".recover_btn").click(function() {
        $("#recover").slideToggle("");
    });
});

if($('.parallax_mv').length){
	const opacityKey = $('.page-area').offset().top;
	
	$(window).on('scroll',function(){
		const opacity = 1 - $(this).scrollTop()/opacityKey;
		$('.parallax_mv').css('opacity', opacity );
	});
}

$(function () {
	$('.header_main_sec_list02 li.MuneOn').hover(
		function(){
		$(this).addClass('active');
	},
	function(){
		$(this).removeClass('active');
	});
});
$(function() {
	$('.sp-accordion').css("display", "none");
	$('.accordion-MuneOn').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
			$(this).next('.sp-accordion').slideUp();
		} else {
			$(this).addClass('open');
			$(this).next('.sp-accordion').slideToggle();
		}
  });
});

$(function() {
    if (window.matchMedia("(min-width: 768px)").matches) {
        if($(".header-infomation").length){
            $("body.index #fv").css("padding-top",$(".header-infomation").outerHeight());
            $("body.index #fv").css("background",$(".pc_header_search_box").css("background"));
        }
    }
    
});